import Payment from "components/Payment";
import AuthPage from "components/shared/AuthPage";

const PaymentPage = () => {
    return (
        <AuthPage userAuthenticated={true} pageName="payments">
            <Payment />
        </AuthPage>
    );
};

export default PaymentPage;
